module.exports = __webpack_public_path__ + "img/tigre-home-second-min.4ee60027.png";